module.exports = __webpack_public_path__ + "img/NOLCardGapShockPressureTable-min.61e59d20.png";